import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-vismad',
  templateUrl: './vismad.component.html',
  styleUrls: ['./vismad.component.scss']
})

export class VismadComponent implements OnInit {
  pdfSrc: string[] = [
    '/assets/pdf/VISMAD2025-26.pdf',
    '/assets/pdf/VISMAD2022-23.pdf',
    '/assets/pdf/VISMAD2020-21.pdf',
  ];
  src: string;
  isLoading = true;
  showPdf: boolean;
  ngOnInit(): void {
    this.changeRoute('2025-26');
  }

  changeRoute(year: string) {
    this.isLoading = true;

    if (year == '2025-26') {
      $('.first').removeClass('active');
      $('.second').removeClass('active');
      $('.third').addClass('active');
      this.src = this.pdfSrc[0];
      this.showPdf = true;
    }

    if (year == '2022-23') {
      $('.third').removeClass('active');
      $('.second').removeClass('active');
      $('.first').addClass('active');
      this.src = this.pdfSrc[1];
      this.showPdf = true;
    }
    if (year == '2020-21') {
      $('.third').removeClass('active');
      $('.first').removeClass('active');
      $('.second').addClass('active');
      this.src = this.pdfSrc[2];
      this.showPdf = false;
    }
  }
  hideLoader() {
    this.isLoading = false;
  }

}